import React from 'react';
import PropTypes from 'prop-types'
import CLIENT_ENDPOINTS from '../../../constants/client-endpoints'
import { Navbar, Nav } from 'react-bootstrap'
import { LinkContainer } from 'react-router-bootstrap'
import UserDropdownMenu from './user-dropdown-menu'
import SealBlack from './seal-black.png'


const Header = () => {
  
    return (
        <React.Fragment>
            <Navbar expand='lg' bg='primary' variant='dark' fixed="top">
                <Navbar.Toggle aria-controls='basic-navbar-nav' />
                <Navbar.Collapse id='basic-navbar-nav'>
                    <LinkContainer to={CLIENT_ENDPOINTS.ROOT}>
                        <Navbar.Brand className='text-center'>
                            <img
                                src={SealBlack}
                                width="60"
                                height="60"
                                className="d-inline-block align-top"
                                alt="DSHA Applied Wellness"
                                title='DSHA Applied Wellness'
                            />
                        </Navbar.Brand>
                    </LinkContainer>
                    <Nav className='ml-auto'>
                        <UserDropdownMenu />
                    </Nav>
                </Navbar.Collapse>
            </Navbar>
        </React.Fragment>
    )
}

Header.propTypes = {
    name: PropTypes.string,
    onLogout: PropTypes.func
}

Header.defaultProps = {
    onLogout: () => {}
}

export default Header
